import { render, staticRenderFns } from "./ck.vue?vue&type=template&id=2071059f&"
import script from "./ck.vue?vue&type=script&lang=js&"
export * from "./ck.vue?vue&type=script&lang=js&"
import style0 from "./ck.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports